import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ITaxaOpcional } from '@vip/core';

@Component({
  selector: 'vip-card-taxa-opcional',
  standalone: false,
  templateUrl: './card-taxa-opcional.component.html',
  styleUrl: './card-taxa-opcional.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardTaxaOpcionalComponent {
  @Input() taxaOpcional?: ITaxaOpcional | null = null;
  @Input() isTaxaOpcionalSelecionada = false;
  @Output() toggleTaxaOpcional = new EventEmitter<boolean>();

  onToggle(): void {
    this.toggleTaxaOpcional.emit(!this.isTaxaOpcionalSelecionada);
  }
}
